import React, { useEffect, useState } from 'react'
import { ProtectedPage } from '~/src/components/templates'
import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { AddSupportHistoryForm } from '~/src/components/pages/AddMemberSupportHistory/components/AddSupportHistoryForm'
import { supportHistoryRepository } from '~/src/repositories'
import { ISupportHistoryListResponse } from '~/src/repositories/SupportHistoryRepository/models/SupportHistoryList'
import { useParams } from 'react-router-dom'
import { IFormValue } from '~/src/components/pages/AddMemberSupportHistory/hooks/useForm'

export const AddMemberSupportHistory: React.FC = (): JSX.Element => {
  const { t } = useTranslation()
  const params = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [listSupportHistory, setListSupportHistory] =
    useState<ISupportHistoryListResponse['data']>()
  const id = Number(params.userId)

  useEffect(() => {
    handleGetSupportHistory()
  }, [id])

  const handleGetSupportHistory = async (): Promise<void> => {
    try {
      setIsLoading(true)
      const listSupportHistory = await supportHistoryRepository.getSupportHistory(id)
      setListSupportHistory(listSupportHistory.data)
    } catch (e: any) {
      console.log(e.message)
    } finally {
      setIsLoading(false)
    }
  }
  const handleSubmit = async (values: IFormValue) => {
    try {
      await supportHistoryRepository.post({
        adminId: values.manager,
        userId: values.member,
        message: values.message,
      })
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <ProtectedPage>
      <Paper sx={{ pt: 2 }}>
        <Typography
          variant={'h2'}
          sx={{
            fontSize: '20px',
            lineHeight: '32px',
            fontWeight: 500,
            color: '#000000',
            marginBottom: '17px',
          }}
          p={2}
        >
          {t('add_support_history.history')}
        </Typography>
        <AddSupportHistoryForm
          list={listSupportHistory}
          isLoading={isLoading}
          onSubmit={handleSubmit}
        />
      </Paper>
    </ProtectedPage>
  )
}
